import React from 'react';
import Routes from './routes/Routes';
import {SesionProvider} from './context/SesionContext';
import {ValidateProvider} from './context/ValidateContext';
import "./App.scss";
function App() {
  /**
   * SesionProvider 
   */
  return (
    <SesionProvider>
      <ValidateProvider>
        <Routes/>
      </ValidateProvider>
    </SesionProvider>
  );
}

export default App;
